import Image from "next/image";
import { formatRelativeDate, formatEpisodeDuration } from "utils/datetime";
import { useTranslation } from "next-i18next";

export default function EpisodeListItem({
  episode,
}: {
  episode: { id: string; title: string; published_at: string; duration: string; image_url: string };
}) {
  const { t, i18n } = useTranslation("common");

  return (
    <div key={episode.id}>
      <div className="flex w-full items-center gap-4">
        <button className="group flex flex-1 items-center justify-between gap-4 rounded-md text-left focus:outline-none focus-visible:shadow-input-focus">
          <div className="flex items-center gap-4">
            <div
              className={`h-14 w-14 shrink-0 rounded-md ${episode.image_url ? "" : "bg-white/50"}`}
            >
              {episode.image_url && (
                <div className="relative flex h-14 w-14 items-center justify-center">
                  <Image
                    layout="fill"
                    className={`flex h-14 w-14 shrink-0  rounded-md transition`}
                    src={episode.image_url}
                    alt={episode.title}
                  />
                </div>
              )}
            </div>
            <div className="transition duration-500 group-hover:translate-x-1">
              <div className="font-semibold text-white">
                <span className="block whitespace-normal  ">{episode.title}</span>
              </div>
              <div className="flex flex-wrap items-center text-[13px] text-white/70">
                {formatRelativeDate(episode.published_at, i18n.language)}
                <span className="text-white/50 md:hidden lg:flex">
                  &nbsp;<span className="font-light text-white/70"> &bull; </span>&nbsp;
                  {t("Episode")}
                </span>{" "}
              </div>
            </div>
          </div>

          <div className="hidden shrink-0 whitespace-nowrap text-[13px] font-medium text-white/50 lg:block">
            {formatEpisodeDuration(episode.duration)}
          </div>
        </button>
      </div>
    </div>
  );
}
